@if (copy) {
  <div class="tw-px-4 tw-pb-4 tw-overflow-visible tw-relative tw-font-body">
    <div class="tw-px-5 tw-py-4 tw-box-border tw-bg-white tw-rounded-xl tw-shadow-z3">
      <div [class]="titleSizeClass" class="tw-font-bold tw-mb-1">{{ copy.title }}</div>
      <div [class]="descriptionSizeClass" class="tw-text-gray-700">
        <div class="tw-font-semibold tw-mb-1">{{ copy.reasonsHeading }}</div>
        <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
          @for (reason of copy.reasons; track reason) {
            <li>{{ reason }}</li>
          }
        </ul>
      </div>
    </div>
  </div>
}
